"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var AgentResource = /** @class */ (function (_super) {
    tslib_1.__extends(AgentResource, _super);
    function AgentResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AgentResource.endpoint = '/agents';
    AgentResource.MODEL_NAME = 'agent';
    return AgentResource;
}(base_1.default));
exports.default = AgentResource;
//# sourceMappingURL=agent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/agent.js
// module id = SQLL
// module chunks = 0